import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import throttle from 'lodash/throttle';

const cardImageContentBlocks = document.querySelectorAll(
	'.block-card-image-content.is-style-background_image .swiper'
);

if (cardImageContentBlocks.length > 0) {
	const initBlock = (block) => {
		const settings = {
			grabCursor: true,
			spaceBetween: 20,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				nextEl: block
					.closest('.block-card-image-content')
					?.querySelector('.swiper-button-next'),
				prevEl: block
					.closest('.block-card-image-content')
					?.querySelector('.swiper-button-prev'),
			},
		};

		let swiperInstance =
			window.innerWidth < 768 ? new Swiper(block, settings) : null;

		window.addEventListener(
			'resize',
			throttle(() => {
				if (window.innerWidth >= 768 && swiperInstance) {
					swiperInstance.destroy();
					swiperInstance = null;
				} else if (window.innerWidth < 768 && !swiperInstance) {
					swiperInstance = new Swiper(block, settings);
				}
			}, 100)
		);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initBlock(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	cardImageContentBlocks.forEach((block) => observer.observe(block));
}
